module.exports = __webpack_public_path__ + "img/testcaseinvalid.8f81665a.svg";